export const LOCALE = (globalThis.I18n || {}).locale;

function round(value, decimals) {
  if (value === null || value === undefined) {
    return ' ';
  } else {
    const number = Number.parseFloat(value);
    const options = {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    };
    return number.toLocaleString(LOCALE, options);
  }
}

export default round;
